export const BASE_FLIRT_URL = process.env.NEXT_PUBLIC_FLIRT_ENDPOINT;
export const PROMOBOX_MANAGER_PATH = '/Promobox/edit.productpromoboxmanagemodel.details.html';
export const COLLECTIONS_BASE_URL = BASE_FLIRT_URL + '/collectionsNicolle';
